import React from "react";
import {
  Box, Checkbox, Flex, FormControl, FormLabel, Select, Text,
} from "@chakra-ui/react";
import {
  EXAM_OPTIONS,
  getExamValue,
  QUESTION_TYPE_OPTIONS,
  SUBJECT_OPTIONS,
  YEAR_OPTIONS,
  normalizeAnswerMetadata,
} from "../constants/answerMetadata";

export default function AnswerMetadataFields({ value, onChange }) {
  const update = (fields) =>
    onChange(normalizeAnswerMetadata({ ...value, ...fields }));
  const field = (label, current, options, onSelect) => (
    <FormControl flex="1" minW="125px">
      <FormLabel fontSize="xs" mb="1">{label}</FormLabel>
      <Select
        size="sm"
        aria-label={label}
        value={current || ""}
        onChange={(event) => onSelect(event.target.value)}
      >
        <option value="">선택 안 함</option>
        {options.map(([key, text]) => (
          <option value={key} key={key}>{text}</option>
        ))}
      </Select>
    </FormControl>
  );
  return (
    <Box>
      {field("과목", value.subject_code, SUBJECT_OPTIONS, (subject_code) =>
        update({ subject_code }),
      )}
      <Checkbox
        size="sm"
        my="3"
        isChecked={value.is_past_exam}
        onChange={(event) => update({ is_past_exam: event.target.checked })}
      >
        기출문제 풀이
      </Checkbox>
      {value.is_past_exam && (
        <>
          <Flex wrap="wrap" gap="2">
            {field("문형", value.question_type, QUESTION_TYPE_OPTIONS, (question_type) =>
              update({ question_type }),
            )}
            {field("기출 연도", value.exam_year, YEAR_OPTIONS, (year) =>
              update({ exam_year: year ? Number(year) : null }),
            )}
            {field("시험", getExamValue(value), EXAM_OPTIONS, (exam) =>
              update({
                exam_type: exam.startsWith("bar_mock_") ? "bar_mock" : exam || null,
                exam_round: exam.startsWith("bar_mock_") ? Number(exam.slice(-1)) : null,
              }),
            )}
          </Flex>
          <Text fontSize="xs" color="gray.500" mt="2">
            문형·연도·시험을 선택하면 목록에서 쉽게 찾을 수 있습니다.
          </Text>
        </>
      )}
    </Box>
  );
}
